"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDiv = exports.NodeImage = exports.NodeTitle = exports.SystemLink = exports.CompareTable = exports.ErrorContainer = exports.ResultVisualizer = exports.NodeExpander = exports.NodeHeader = exports.NodeList = exports.ResultTable = exports.ResultTableContainer = exports.DataControlContainer = exports.InputRowContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InputRowContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding-top: 10px;
  padding-bottom: 10px;

  input {
    margin-right: 10px;
  }
`;
exports.DataControlContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: 10px;
  margin-left: 40px;

  button {
    margin-bottom: 10px;
  }
`;
exports.ResultTableContainer = styled_components_1.default.div `
  background-color: #fff;
  border-radius: 15px;
  margin-left: 30px;
`;
exports.ResultTable = styled_components_1.default.table `
  margin: 15px;

  > thead {
    > tr {
      > th {
        font-weight: bold;
        padding: 3px;
        text-align: left;
      }
      > th:first-child {
        padding-left: 49px;
      }
    }
  }

  > tbody {
    > tr:nth-child(2n) {
      > td {
        padding-top: 0px;
        padding-bottom: 0px;
        border-bottom: 1px solid #999;
      }
    }
    > tr {
      > td {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 5px;
        padding-right: 5px;
        vertical-align: middle;
        width: 120px;
      }
      > td:first-child {
        width: 300px;
      }
    }

    > tr:nth-child(1) {
      > td {
        border-top: 1px solid #999;
      }
    }
  }
`;
exports.NodeList = styled_components_1.default.ul `
  margin-left: 20px;
  ul {
    margin-left: 20px;
    padding: 5px;
  }

  li {
    padding: 5px;
  }
`;
exports.NodeHeader = styled_components_1.default.button `
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding-left: 0;
  padding-right: 0;
`;
exports.NodeExpander = styled_components_1.default.span `
  width: 20px;
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  vertical-align: middle;
`;
exports.ResultVisualizer = styled_components_1.default.img `
  width: 16px;
  height: 16px;
  margin-left: 3px;
  margin-right: 5px;
  vertical-align: middle;
`;
exports.ErrorContainer = styled_components_1.default.div `
  margin-left: 20px;
`;
exports.CompareTable = styled_components_1.default.table `
  > tbody {
    > tr {
      > th {
        padding: 5px;
      }
      > td {
        padding: 5px;
      }
    }
  }
`;
exports.SystemLink = styled_components_1.default.a ``;
exports.NodeTitle = styled_components_1.default.span `
  vertical-align: middle;
`;
exports.NodeImage = styled_components_1.default.img `
  width: 12px;
  height: 12px;
  vertical-align: middle;
`;
exports.StyledDiv = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-left: 15px;
  margin-bottom: -10px;

  > span {
    margin-left: 5px;
  }
`;
//# sourceMappingURL=elements.js.map